"use strict";
// tslint:disable
/**
 * Learning platform
 * API for ROH Learning platform
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceTypes = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var SliceTypes;
(function (SliceTypes) {
    SliceTypes["RichTextSection"] = "rich_text_section";
    SliceTypes["CarouselTray"] = "carousel_tray";
    SliceTypes["CoverImageHeader"] = "cover_image_header";
    SliceTypes["SetOfCards"] = "set_of_cards";
    SliceTypes["SetOfProgrammes"] = "set_of_programmes";
    SliceTypes["CoursesList"] = "courses_list";
    SliceTypes["ProgrammeInfo"] = "programme_info";
    SliceTypes["AdditionalResources"] = "additional_resources";
    SliceTypes["CourseInformation"] = "course_information";
    SliceTypes["AsideContent"] = "aside_content";
    SliceTypes["ListOfLessons"] = "list_of_lessons";
    SliceTypes["LessonsInformation"] = "lessons_information";
    SliceTypes["UnitRelationship"] = "unit_relationship";
    SliceTypes["ListOfVideos"] = "list_of_videos";
    SliceTypes["PdfDocuments"] = "pdf_documents";
    SliceTypes["UsefulLink"] = "useful_link";
    SliceTypes["PageTitle"] = "page_title";
    SliceTypes["EventsList"] = "events_list";
    SliceTypes["EventInformation"] = "event_information";
    SliceTypes["RequestedCourses"] = "requested_courses";
    SliceTypes["EventDetails"] = "event_details";
    SliceTypes["EventBrightEvents"] = "event_bright_events";
    SliceTypes["TableContent"] = "table_content";
    SliceTypes["Accordion"] = "accordion";
})(SliceTypes = exports.SliceTypes || (exports.SliceTypes = {}));
